// window.matchMedia 를 구독해 미디어쿼리 일치 여부를 돌려주는 훅 (MUI useMediaQuery 대체)
import { useEffect, useState } from 'react';

const getMatches = (query: string) =>
    typeof window !== 'undefined' && window.matchMedia(query).matches;

export default function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(() => getMatches(query));

    useEffect(() => {
        const media = window.matchMedia(query);
        const onChange = (event: MediaQueryListEvent) =>
            setMatches(event.matches);

        setMatches(media.matches);
        media.addEventListener('change', onChange);

        return () => media.removeEventListener('change', onChange);
    }, [query]);

    return matches;
}
